// Module
var code = `<div class="hc-item-cc">
  <div class="hc-item-cc-header">
    <div class="hc-item-cc-header-wrapper">
      <div>#:</div>
      <div>Name:</div>
      <div>Description:</div>
      <div>Status:</div>
      <div></div>
    </div>
  </div>
  <div class="hc-item-cc-row"
  ng-repeat="check in \$ctrl.checks"
  ng-class="check.status === 'OK'? 'ok' : 'fail'"
  ng-init="check.show = false">
    <div class="hc-item-cc-row-wrapper" ng-class="{'hc-item-cc-row-wrapper-detailed': check.show }">
      <div>{{ \$index + 1 }}</div>
      <div>{{ check.name }}</div>
      <div>{{ check.description }}</div>
      <div><span class="status" ng-class="check.status === 'FAILED' ? 'fail' : 'ok'">{{ check.status }}</span></div>
      <div ng-click="check.show = !check.show" class="hc-item-cc-row-action">
        <span ng-if="!check.show">Show </span>
        <span ng-if="check.show">Hide </span>
        details
      </div>
    </div>
    <div class="hc-item-cc-row-table" ng-if="check.show">
      <table class="hc-item-table">
        <tr ng-repeat="detail in check.details"><td>{{ detail }}</td></tr>
      </table>
    </div>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/health-check-list/close-counters-health-check/close-counters-health-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;